import { tokenSyncService } from '@/services/tokenSync';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: '@multimarcas:access_token',
  REFRESH_TOKEN: '@multimarcas:refresh_token',
  USER: '@multimarcas:user',
  TENANT: '@multimarcas:tenant',
  LAST_ACTIVITY: '@multimarcas:last_activity'
} as const;

export const TokenStorage = {
  getAccessToken: () => {
    try {
      return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
    } catch {
      return null;
    }
  },

  getRefreshToken: () => {
    try {
      return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
    } catch {
      return null;
    }
  },

  getUser: () => {
    try {
      const user = localStorage.getItem(STORAGE_KEYS.USER);
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  },
  
  setTokens: (accessToken: string, refreshToken: string) => {
    try {
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
      localStorage.setItem(STORAGE_KEYS.LAST_ACTIVITY, Date.now().toString());
      
      // Configura o token no localStorage e também em memória
      if (typeof window !== 'undefined') {
        (window as any).__multimarcas_access_token = accessToken;
      }
    } catch (error) {
      console.error('Erro ao salvar tokens:', error);
    }
  },
  
  setUser: (user: any) => {
    try {
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
    } catch (error) {
      console.error('Erro ao salvar usuário:', error);
    }
  },
  
  clearSession: (notifyOtherTabs = true) => {
    try {
      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USER);
      localStorage.removeItem(STORAGE_KEYS.TENANT);
      localStorage.removeItem(STORAGE_KEYS.LAST_ACTIVITY);
      
      // Limpa também da memória
      if (typeof window !== 'undefined') {
        delete (window as any).__multimarcas_access_token;
      }

      // Notifica outras abas sobre a limpeza da sessão apenas se solicitado
      if (notifyOtherTabs) {
        tokenSyncService.notifySessionCleared();
      }
    } catch (error) {
      console.error('Erro ao limpar sessão:', error);
    }
  },

  isSessionValid: () => {
    try {
      const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      if (!token) return false;
      
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expirationTime = payload.exp * 1000; // Converter para milissegundos
      
      // Verifica também a última atividade
      const lastActivity = localStorage.getItem(STORAGE_KEYS.LAST_ACTIVITY);
      const inactivityLimit = 24 * 60 * 60 * 1000; // 24 horas
      
      if (lastActivity) {
        const inactiveTime = Date.now() - parseInt(lastActivity);
        if (inactiveTime > inactivityLimit) {
          TokenStorage.clearSession();
          return false;
        }
      }
      
      return Date.now() < expirationTime;
    } catch {
      return false;
    }
  },

  updateLastActivity: () => {
    try {
      localStorage.setItem(STORAGE_KEYS.LAST_ACTIVITY, Date.now().toString());
    } catch (error) {
      console.error('Erro ao atualizar última atividade:', error);
    }
  }
} as const; 